// const OrderPage = () => import('/src/components/order/Index')

// const Step3DsResult = () => import('/src/components/order/completed/Step3DsResult')
// const StepPaymentCash = () => import('/src/components/order/completed/StepPaymentCash')
// const StepPaymentSuccess = () => import('/src/components/order/completed/StepPaymentSuccess')
// const StepPaymentFail = () => import('/src/components/order/completed/StepPaymentFail')

const PaymentResultPage = () => import('@/views/dashboard/PaymentResultPage.vue')

// const StepPaymentRecall = () => import('/src/components/order/completed/StepPaymentRecall')

export default {
  path: '/dashboard/order/:hid/payment/:action?',
  name: 'PaymentsPage',
  component: PaymentResultPage,
  meta: {
    requiresAuth: true,
    globalPlacement: 'dashboard',
  },
  props: true,
}
